<script>
  import {
    Card,
    Accordion,
    Button,
    Text,
    Image,
    Title,
  } from "@svelteuidev/core";
  import Constantes from "../../Classes/Constantes";
  import Conexoes from "../../Classes/Conexoes";
  import LoadingTela from "../../componentes_basicos/LoadingTela.svelte";
  import { onMount } from "svelte";
  import "@fortawesome/fontawesome-free/css/all.css";
  import { navigate } from "svelte-routing";
  import ArmazenaVariaveisInscricao from "../../Classes/ArmazenaVariaveisInscricao";
  export let id_campeonato;
  let api = Constantes.api_consultar_padrao;
  let conexoes = new Conexoes();
  let retorno = {};
  let carregando = false;
  // let proximaPagina = "/inscricao/"+id_campeonato;
  let proximaPagina = "/inscricao?id=" + id_campeonato;
  let voltarPagina = "/campeonatos";
  async function PegarDados() {
    carregando = true;
    await id_campeonato;
    retorno = await conexoes.conecta(api, {
      query_code: Constantes.query_code_consultar_campeonato,
      id_campeonato: id_campeonato,
    });
    retorno = retorno[0];
    ArmazenaVariaveisInscricao.atualizarDados(retorno);
    carregando = false;
   // console.log("retorno", retorno);
  }
  onMount(async () => {
    PegarDados();
    await id_campeonato;
    //console.log("id campeonato ", id_campeonato);
  });
</script>

<LoadingTela isLoading={carregando} />
{#if retorno}
  <div class="container">
    <div>
      <Accordion defaultValue="1">
        <Accordion.Item value="1" disabled>
          <div slot="control">Sobre o evento</div>
          <Card shadow="sm" padding="lg">
            <Card.Section
              first
              padding="lg"
              style="display: flex; justify-content: center;"
            >
              <Image
                src={retorno.imageUrl}
                width={200}
                height={200}
                alt="Imagem"
              />
            </Card.Section>
          </Card>
          <Card shadow="sm" padding="lg">
            <div class="descricao">
              <Text size="lg">
                {@html retorno.descricao}
              </Text>
            </div>
          </Card>
        </Accordion.Item>
      </Accordion>

      <Accordion
        defaultValue="evento"
        chevronPosition="left"
        variant="separated"
      >
        {#if retorno.titulo_secao2}
          <Accordion.Item value={retorno.titulo_secao1}>
            <div slot="control">
              <Title order={4} color="#3659fc">{retorno.titulo_secao1}</Title>
            </div>

            <div class="secao">
              <h5>
                {@html retorno.texto_secao1}
              </h5>
              <br />
            </div>
            <div class="precos">
              {@html retorno.precos}
            </div>
          </Accordion.Item>
        {/if}
        {#if retorno.titulo_secao2}
          <Accordion.Item value={retorno.titulo_secao2}>
            <div slot="control">
              <Title order={4} color="#3659fc"
                >{@html retorno.titulo_secao2}</Title
              >
            </div>
            <div class="secao">
              <h5>
                {@html retorno.texto_secao2}
              </h5>
              <br />
            </div></Accordion.Item
          >
        {/if}
        {#if retorno.titulo_secao3}
          <Accordion.Item value={retorno.titulo_secao3}>
            <div slot="control">
              <Title order={4} color="#3659fc">{retorno.titulo_secao3}</Title>
            </div>
            <div class="secao">
              <h5>
                {@html retorno.texto_secao3}
              </h5>
              <br />
            </div></Accordion.Item
          >
        {/if}
      </Accordion>

    <div>
    <div class="buttons-container">
      <button
        on:click={() => navigate(voltarPagina)}
        class="btn btn-outline-primary left-button"
      >
        <i class="fas fa-arrow-left"></i>
        {Constantes.titulo_botao_voltar}
      </button>
      <button
        on:click={() => navigate(proximaPagina)}
        class="btn btn-primary right-button"
      >
        {Constantes.titulo_ir_para_inscricao}
        <i class="fas fa-arrow-right"></i>
      </button>
    </div>
  </div>


    </div>
  </div>

{/if}

<style>
  .container {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100vh;
    margin-top: 3em;
    margin-bottom: 1em;
  }

  .card-container {
    width: 100%;
    max-width: 100%;
    text-align: center;
  }

  .image {
    height: 80%;
    width: 80%;
  }

  .descricao {
    margin: 2em;
  }
  .secao {
    text-align: left;
    padding: auto;
  }
  .precos {
    text-align: left; /* Alinha o conteúdo dos preços à esquerda */
  }
  .buttons-container {
    display: flex;
    justify-content: space-between;
    margin-top: 2em;
    margin-bottom: 6em;
    width: 100%; /* Certifique-se de que os botões ocupem toda a largura disponível */
  }

  .buttons-container button {
    flex: 1; /* Faz com que os botões ocupem igualmente o espaço disponível */
    margin: 0 1em; /* Adiciona espaço entre os botões */
  }

  .left-button,
  .right-button {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .left-button i,
  .right-button i {
    margin: 0 0.5em;
  }
</style>
